import api from './apiService';

export const reportService = {
  // Get all reports
  async getReports(params = {}) {
    try {
      const response = await api.get('/reports', { params });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch reports:', error);
      throw error;
    }
  },

  // Get report by ID
  async getReportById(reportId) {
    try {
      const response = await api.get(`/reports/${reportId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch report:', error);
      throw error;
    }
  },

  // Create new report
  async createReport(reportData) {
    try {
      console.log('Creating report with data:', JSON.stringify(reportData, null, 2));
      const response = await api.post('/reports', reportData);
      return response.data;
    } catch (error) {
      console.error('Failed to create report:', error);
      if (error.response?.data) {
        console.error('Server response:', error.response.data);
      }
      throw error;
    }
  },

  // Update report
  async updateReport(reportId, updateData) {
    try {
      const response = await api.put(`/reports/${reportId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Failed to update report:', error);
      throw error;
    }
  },

  // Delete report
  async deleteReport(reportId) {
    try {
      const response = await api.delete(`/reports/${reportId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to delete report:', error);
      throw error;
    }
  },

  // Generate report data
  async generateReport(reportId, options = {}) {
    try {
      const response = await api.post(`/reports/${reportId}/generate`, options);
      return response.data;
    } catch (error) {
      console.error('Failed to generate report:', error);
      throw error;
    }
  },

  // Get report templates
  async getReportTemplates() {
    try {
      const response = await api.get('/reports/templates/list');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch report templates:', error);
      throw error;
    }
  },

  // Create report from template
  async createFromTemplate(templateId, reportData) {
    try {
      const response = await api.post(`/reports/templates/${templateId}/create`, reportData);
      return response.data;
    } catch (error) {
      console.error('Failed to create report from template:', error);
      throw error;
    }
  },

  // Get report statistics
  async getReportStats() {
    try {
      const response = await api.get('/reports/stats/overview');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch report statistics:', error);
      throw error;
    }
  },

  // Share report
  async shareReport(reportId, userIds, permission = 'view') {
    try {
      const response = await api.post(`/reports/${reportId}/share`, {
        userIds,
        permission
      });
      return response.data;
    } catch (error) {
      console.error('Failed to share report:', error);
      throw error;
    }
  },

  // Duplicate report
  async duplicateReport(reportId, name) {
    try {
      const response = await api.post(`/reports/${reportId}/duplicate`, { name });
      return response.data;
    } catch (error) {
      console.error('Failed to duplicate report:', error);
      throw error;
    }
  }
};

export default reportService;
